import gql from 'graphql-tag';
import { VendorLayerFragment } from '@/graphql/fragments';

export default gql`
  query nodeQuery($id: ID!) {
    node(id: $id) {
      __typename
      ...VendorLayerFragment
    }
  }
  ${VendorLayerFragment}
`;
